import { render, staticRenderFns } from "./dashboardMateriales.vue?vue&type=template&id=f3a390a6&scoped=true&"
import script from "./dashboardMateriales.vue?vue&type=script&lang=js&"
export * from "./dashboardMateriales.vue?vue&type=script&lang=js&"
import style0 from "./dashboardMateriales.vue?vue&type=style&index=0&id=f3a390a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a390a6",
  null
  
)

export default component.exports